import React from "react";
import BackButton from "../components/BackButton"; 

function FairPlayPolicy() {
    return (
        <div style={{ minHeight: "100vh", background: "#f4f6f9", paddingBottom: "50px", fontFamily: "'Poppins', sans-serif" }}>
            
            <div className="pb-5 pt-4 px-3 position-relative overflow-hidden"
                style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "30px", borderBottomRightRadius: "30px", boxShadow: "0 10px 20px rgba(128,0,0,0.15)" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <BackButton className="text-white" />
                    <div style={{ width: 30 }}></div>
                </div>
                <div className="text-center pb-3">
                    <h3 className="fw-bolder text-white mb-1">Fair Play Policy</h3>
                    <p className="text-white opacity-75 small mb-0">Ensuring an honest competition</p>
                </div>
            </div>

            <div className="container px-3" style={{ marginTop: "-30px" }}>
                <div className="card border-0 shadow-sm rounded-4 p-4 animate-up border border-danger border-opacity-25 mb-4">
                    <div className="text-center mb-4">
                        <i className="bi bi-shield-fill-check text-success display-4"></i>
                        <p className="text-muted small mt-2">Win11 Fantasy is committed to providing a transparent, skill-based, and level playing field for all users.</p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-person-x-fill text-danger me-2"></i>1. One User, One Account Policy</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            Every individual is strictly allowed to operate only one account. Our system monitors device IDs, IP addresses, and financial linkages. If multiple accounts are detected belonging to the same user to exploit referral bonuses or manipulate contests, all associated accounts will be banned.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-robot text-danger me-2"></i>2. Prohibition of Bots & Scripts</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            The use of automated scripts, bots, unauthorized APIs, or third-party software to create teams, join contests in bulk, or scrape platform data is strictly forbidden. Win11 employs advanced security algorithms to detect non-human interactions.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-people-fill text-danger me-2"></i>3. Anti-Collusion & Syndicate Play</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            Users are not permitted to coordinate with others to form "syndicates" aimed at manipulating contest outcomes or increasing win probabilities unfairly. Any group behavior detected by our fraud-control systems will lead to immediate disqualification.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-cash-coin text-danger me-2"></i>4. Financial Fraud & Chargebacks</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            Any attempt to use unauthorized or stolen credit/debit cards, or initiating unjustified bank chargebacks after participating in contests, will be treated as financial fraud. Such actions will lead to account termination and potential legal prosecution.
                        </p>
                    </div>

                    <div className="bg-danger bg-opacity-10 p-3 rounded-3 mt-4">
                        <h6 className="fw-bold text-danger"><i className="bi bi-exclamation-triangle-fill text-danger me-2"></i>Consequences of Violation</h6>
                        <p className="text-danger small mb-0 fw-semibold" style={{ lineHeight: "1.6" }}>
                            Violating any aspect of the Fair Play Policy will result in:
                            <br/>• Immediate and irreversible account deactivation.
                            <br/>• Complete forfeiture of all wallet balances and pending winnings.
                            <br/>• Reporting to financial institutions and legal authorities if necessary.
                        </p>
                    </div>
                </div>
            </div>

            <style>{`
                .animate-up { animation: fadeInUp 0.4s ease-out both; }
                .policy-section { border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px; }
                @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}

export default FairPlayPolicy;